<template>
  <div style="width: 100%; height: 100%">
    <section>
      <div style="display: flex">
        <!-- 答题卡区域 -->
        <div class="leftPreview">
          <el-scrollbar style="height: 100%">
            <div style="width: 250px">
              <div class="title2">
                <i class="el-icon-date"></i>&nbsp;&nbsp;答题卡
              </div>
              <div class="leftimg" v-if="examList == ''">
                <!-- <img src="../../assets/images/exam/暂无数据.png" /><br /> -->
                <span style="color: #b2b8bd; margin-left: 4px">暂无数据</span>
              </div>
              <div class="leftdiv" v-if="examList !== ''">
                <span class="allscore-text">总分：{{allScore}}</span>
              </div>
              <div class="nr" v-if="dxt != 0">
                <span style="padding-left: 22px">单选题</span>
                <span style="padding-left: 10px">(共{{ dxt }}题，合计{{ dxtSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="dxt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index1) in examList"
                    :key="index1"
                    @click="jump(item.id)"
                    v-if="item.type == 1"
                  >
                    <div :class="['top', item.isRight ? 'top-true' : 'top-false']">
                      <span
                        style="padding-left: 6px; font-size: 14px; color: white"
                      >{{ index1 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nr" v-if="ddxt != 0">
                <span style="padding-left: 22px">多选题</span>
                <span style="padding-left: 10px">(共{{ ddxt }}题，合计{{ ddxtSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="ddxt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index2) in examList"
                    :key="index2"
                    @click="jump(item.id)"
                    v-if="item.type == 2"
                  >
                    <div
                      :class="[
                      'top',
                      item.isRight
                        ? 'top-true'
                        : 'top-false',
                    ]"
                    >
                      <span
                        style="padding-left: 6px; font-size: 14px; color: white"
                      >{{ index2 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nr" v-if="pdt != 0">
                <span style="padding-left: 22px">判断题</span>
                <span style="padding-left: 10px">(共{{ pdt }}题，合计{{ pdtSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="pdt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index3) in examList"
                    :key="index3"
                    @click="jump(item.id)"
                    v-if="item.type == 3"
                  >
                    <div
                      :class="[
                      'top',
                      item.isRight
                        ? 'top-true'
                        : 'top-false',
                    ]"
                    >
                      <span
                        style="padding-left: 6px; font-size: 14px; color: white"
                      >{{ index3 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nr" v-if="tkt != 0">
                <span style="padding-left: 22px">填空题</span>
                <span style="padding-left: 10px">(共{{ tkt }}题，合计{{ tktSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="tkt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index5) in examList"
                    :key="index5"
                    @click="jump(item.id)"
                    v-if="item.type == 4"
                  >
                    <div
                      :class="[
                      'top',
                      item.isRight
                        ? 'top-true'
                        : 'top-false',
                    ]"
                    >
                      <span
                        style="padding-left: 6px; font-size: 14px; color: white"
                      >{{ index5 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nr" v-if="wdt != 0">
                <span style="padding-left: 22px">问答题</span>
                <span style="padding-left: 10px">(共{{ wdt }}题，合计{{ wdtSum }}分)</span>
              </div>
              <div class="leftdiv" v-if="wdt != 0">
                <div style="display: flex; flex-wrap: wrap">
                  <div
                    v-for="(item, index4) in examList"
                    :key="index4"
                    @click="jump(item.id)"
                    v-if="item.type == 5"
                  >
                    <div
                      :class="[
                      'top',
                      item.isRight
                        ? 'top-true'
                        : 'top-false',
                    ]"
                    >
                      <span
                        style="padding-left: 6px; font-size: 14px; color: white"
                      >{{ index4 + 1 }}</span>
                    </div>
                    <div class="bottom">
                      <svg v-if="item.RightNum == true" class="icon" style="margin-left: 5px">
                        <use xlink:href="#iconbiaoji" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <!-- 题目区域 -->
        <div class="zhuti">
          <div class="title" v-if="dxt != 0">
            <span style="padding-left: 30px">单选题</span>
            <span style="padding-left: 10px">(共{{ dxt }}题，合计{{ dxtSum }}分)</span>
          </div>
          <div v-for="(item, index) in examList" :key="index" v-if="item.type == 1">
            <div class="hhh">
              <div class="sss">
                <div class="subject">
                  <span>{{ index + 1 }}.</span>
                  <span v-html="item.title" :id="item.id"></span>
                </div>
                <!-- 判卷 -->
                <div class="question-operation">
                  <ul>
                    <li>
                      <span class="label-name">判题：</span>
                      <i
                        :class="[
                        'el-icon-check',
                        'iconImg',
                        item.isRight
                          ? 'iconImgTrue'
                          : '',
                      ]"
                        @click="btnTrue(item)"
                      ></i>
                      <i
                        :class="[
                        'el-icon-close',
                        'iconImg',
                        item.isRight
                          ? ''
                          : 'iconImgFalse',
                      ]"
                        @click="btnFalse(item)"
                      ></i>
                    </li>
                    <li>
                      <span class="label-name">得分：</span>
                      <el-input-number
                        v-if="
                        item.isRight
                      "
                        v-model="item.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="item.score"
                        :controls="false"
                        @change="changeScore(item)"
                      ></el-input-number>
                      <el-input-number
                        v-else
                        v-model="item.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="0.0"
                        :controls="false"
                        @change="changeScore(item)"
                      ></el-input-number>
                    </li>
                    <li>
                      <span class="label-name">满分：</span>
                      <span>{{ item.score }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <ul>
                  <li v-for="(items, indexs1) in item.answer" :key="indexs1" :id="items.Name">
                    <label :for="items.Id" style="font-size: 15px">
                      <input type="radio" v-model="item.value" :value="items.Id" disabled />
                      {{ items.Name }}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="correct" v-if="item.answer[index]">
                <span v-if="
                  item.isRight
                ">
                  <i class="el-icon-chat-line-square" style="color: green; width: 25px"></i>恭喜你答对啦
                </span>
                <span v-else>
                  <i class="el-icon-chat-line-square" style="color: red; width: 25px"></i>答错了
                </span>
              </div>
              <div class="answer">
                <div v-for="(items, indexs2) in item.answer" :key="indexs2" :id="items.Name">
                  <span v-if="indexs2 == 0 && items.IsRight == true">正确答案：A</span>
                  <span v-if="indexs2 == 1 && items.IsRight == true">正确答案：B</span>
                  <span v-if="indexs2 == 2 && items.IsRight == true">正确答案：C</span>
                  <span v-if="indexs2 == 3 && items.IsRight == true">正确答案：D</span>
                  <div>
                    <span v-if="indexs2 == 0 && items.IsCheck == true">你选择的答案：A</span>
                    <span v-if="indexs2 == 1 && items.IsCheck == true">你选择的答案：B</span>
                    <span v-if="indexs2 == 2 && items.IsCheck == true">你选择的答案：C</span>
                    <span v-if="indexs2 == 3 && items.IsCheck == true">你选择的答案：D</span>
                  </div>
                </div>
                <div style="margin-left: 40px">
                  <span v-if="item.value == ''">你选择的答案：未作答</span>
                </div>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{ item.explain }}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <div class="title" v-if="ddxt != 0">
            <span style="padding-left: 30px">多选题</span>
            <span style="padding-left: 10px">(共{{ ddxt }}题，合计{{ ddxtSum }}分)</span>
          </div>
          <div v-for="(item1, index1) in examList" :key="index1" v-if="item1.type == 2">
            <div class="hhh">
              <div class="sss">
                <div class="subject">
                  <span>{{ index1 + 1 }}.</span>
                  <span v-html="item1.title" :id="item1.id"></span>
                </div>
                <div class="question-operation">
                  <ul>
                    <li>
                      <span class="label-name">判题：</span>
                      <i
                        :class="[
                        'el-icon-check',
                        'iconImg',
                        item1.isRight
                          ? 'iconImgTrue'
                          : '',
                      ]"
                        @click="btnTrue(item1)"
                      ></i>
                      <i
                        :class="[
                        'el-icon-close',
                        'iconImg',
                        item1.isRight
                          ? ''
                          : 'iconImgFalse',
                      ]"
                        @click="btnFalse(item1)"
                      ></i>
                    </li>
                    <li>
                      <span class="label-name">得分：</span>
                      <el-input-number
                        v-if="
                        item1.isRight
                      "
                        v-model="item1.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="item1.score"
                        :controls="false"
                        @change="changeScore"
                      ></el-input-number>
                      <el-input-number
                        v-else
                        v-model="item1.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="0.0"
                        :controls="false"
                        @change="changeScore"
                      ></el-input-number>
                    </li>
                    <li>
                      <span class="label-name">满分：</span>
                      <span>{{ item1.score }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <ul>
                  <li v-for="(items, indexs1) in item1.answer" :key="indexs1" :id="items.Name">
                    <input type="checkbox" v-model="items.IsCheck" :value="items.Id" disabled />
                    <label :for="items.Id" style="font-size: 15px">
                      {{
                      items.Name
                      }}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="correct" v-if="item1.answer">
                <span v-if="
                  item1.isRight
                ">
                  <i class="el-icon-chat-line-square" style="color: green; width: 25px"></i>恭喜你答对啦
                </span>
                <span v-else>
                  <i class="el-icon-chat-line-square" style="color: red; width: 25px"></i>答错了
                </span>
              </div>
              <div class="answer">
                <div class="rightanswer">
                  <div>正确答案：</div>
                  <div v-for="(items, indexs) in item1.answer" :key="indexs">
                    <span v-if="indexs == 0 && items.IsRight == true">A</span>
                    <span v-if="indexs == 1 && items.IsRight == true">B</span>
                    <span v-if="indexs == 2 && items.IsRight == true">C</span>
                    <span v-if="indexs == 3 && items.IsRight == true">D</span>
                  </div>
                </div>
                <div class="mychange">
                  <div v-if="item1.MyCate != ''">我选择的答案：</div>
                  <div v-for="(items, indexs) in item1.answer" :key="indexs">
                    <span v-if="indexs == 0 && items.IsCheck == true">A</span>
                    <span v-if="indexs == 1 && items.IsCheck == true">B</span>
                    <span v-if="indexs == 2 && items.IsCheck == true">C</span>
                    <span v-if="indexs == 3 && items.IsCheck == true">D</span>
                  </div>
                </div>
                <div class="mychange" v-if="item1.MyCate == ''">
                  <span>我选择的答案：未作答</span>
                </div>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{item1.explain}}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <div class="title" v-if="pdt != 0">
            <span style="padding-left: 30px">判断题</span>
            <span style="padding-left: 10px">(共{{ pdt }}题，合计{{ pdtSum }}分)</span>
          </div>
          <div v-for="(item, index2) in examList" :key="index2" v-if="item.type == 3">
            <div class="hhh">
              <div class="sss">
                <div class="subject">
                  <span>{{ index2 + 1 }}.</span>
                  <span v-html="item.title" :id="item.id"></span>
                </div>
                <div class="question-operation">
                  <ul>
                    <li>
                      <span class="label-name">判题：</span>
                      <i
                        :class="[
                        'el-icon-check',
                        'iconImg',
                        item.isRight
                          ? 'iconImgTrue'
                          : '',
                      ]"
                        @click="btnTrue(item)"
                      ></i>
                      <i
                        :class="[
                        'el-icon-close',
                        'iconImg',
                        item.isRight
                          ? ''
                          : 'iconImgFalse',
                      ]"
                        @click="btnFalse(item)"
                      ></i>
                    </li>
                    <li>
                      <span class="label-name">得分：</span>
                      <el-input-number
                        v-if="
                        item.isRight
                      "
                        v-model="item.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="item.score"
                        :controls="false"
                        @change="changeScore"
                      ></el-input-number>
                      <el-input-number
                        v-else
                        v-model="item.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="0.0"
                        :controls="false"
                        @change="changeScore"
                      ></el-input-number>
                    </li>
                    <li>
                      <span class="label-name">满分：</span>
                      <span>{{ item.score }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div style="padding-left: 45px; line-height: 50px">
                <input :name="item.id" type="radio" disabled />
                <label style="font-size: 15px">对</label>
                <input :name="item.id" type="radio" style="margin-left: 20px" disabled />
                <label style="font-size: 15px">错</label>
              </div>
              <div class="correct" v-if="item.answer">
                <span v-if="
                  item.isRight
                ">
                  <i class="el-icon-chat-line-square" style="color: green; width: 25px"></i>恭喜你答对啦
                </span>
                <span v-else>
                  <i class="el-icon-chat-line-square" style="color: red; width: 25px"></i>答错了
                </span>
              </div>
              <div class="answer">
                <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                  <span v-if="items.IsRight == true">正确答案：正确</span>
                  <span v-if="items.IsRight == false">正确答案：错误</span>
                </div>
                <div
                  v-for="(items, indexs2) in item.answer"
                  :key="indexs2"
                  :id="items.Name"
                  style="margin-left: 40px"
                >
                  <span v-if="items.IsCheck == true">你选择的答案：正确</span>
                  <span v-else-if="items.IsCheck == false">你选择的答案：错误</span>
                  <span v-else>你选择的答案：无</span>
                </div>
                <div style="margin-left: 40px">
                  <span v-if="item.value == ''">你选择的答案：未作答</span>
                </div>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{ item.explain }}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <div class="title" v-if="tkt != 0">
            <span style="padding-left: 30px">填空题</span>
            <span style="padding-left: 10px">(共{{ tkt }}题，合计{{ tktSum }}分)</span>
          </div>
          <div v-for="(item, index4) in examList" :key="index4" v-if="item.type == 4">
            <div class="hhh">
              <div class="sss">
                <div class="title-box">
                  <div class="subject">
                    <span>{{ index4 + 1 }}.</span>
                    <span v-html="item.title" :id="item.id"></span>
                  </div>
                  <div>
                    <el-input
                      v-for="(items, indexs2) in item.answer"
                      disabled
                      :key="indexs2"
                      v-model="items.letter"
                      placeholder="请输入内容"
                      style="
                      width: 90%;
                      padding-top: 10px;
                      padding-bottom: 20px;
                    "
                    >
                      <template slot="prepend">{{ indexs2 + 1 }}</template>
                    </el-input>
                  </div>
                </div>
                <div class="question-operation">
                  <ul>
                    <li>
                      <span class="label-name">判题：</span>
                      <i
                        :class="[
                        'el-icon-check',
                        'iconImg',
                        item.isRight
                          ? 'iconImgTrue'
                          : '',
                      ]"
                        @click="btnTrue(item)"
                      ></i>
                      <i
                        :class="[
                        'el-icon-close',
                        'iconImg',
                        item.isRight
                          ? ''
                          : 'iconImgFalse',
                      ]"
                        @click="btnFalse(item)"
                      ></i>
                    </li>
                    <li>
                      <span class="label-name">得分：</span>
                      <el-input-number
                        v-if="
                        item.isRight
                      "
                        v-model="item.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="item.score"
                        :controls="false"
                        @change="changeScore"
                      ></el-input-number>
                      <el-input-number
                        v-else
                        v-model="item.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="0.0"
                        :controls="false"
                        @change="changeScore"
                      ></el-input-number>
                    </li>
                    <li>
                      <span class="label-name">满分：</span>
                      <span>{{ item.score }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="correct" v-if="item.answer">
                <span v-if="
                  item.isRight
                ">
                  <i class="el-icon-chat-line-square" style="color: green; width: 25px"></i>恭喜你答对啦
                </span>
                <span v-else>
                  <i class="el-icon-chat-line-square" style="color: red; width: 25px"></i>答错了
                </span>
              </div>
              <div class="answer">
                <div
                  class="answer-true"
                  v-for="(items, indexs) in item.answer"
                  :key="indexs"
                  style="width: 100%"
                >
                  <p :title="items.Name">正确答案：{{ items.Name }}</p>
                </div>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{ item.explain }}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
          <div class="title" v-if="wdt != 0">
            <span style="padding-left: 30px">问答题</span>
            <span style="padding-left: 10px">(共{{ wdt }}题，合计{{ wdtSum }}分)</span>
          </div>
          <div v-for="(item, index3) in examList" :key="index3" v-if="item.type == 5">
            <div class="hhh">
              <div class="sss">
                <div class="title-box">
                  <div class="subject">
                    <span>{{ index3 + 1 }}.</span>
                    <span v-html="item.title" :id="item.id"></span>
                  </div>
                  <div>
                    <el-input
                      type="textarea"
                      v-for="(items, indexs2) in item.answer"
                      @paste.native.capture.prevent="handlePaste"
                      :key="indexs2"
                      v-model="items.letter"
                      placeholder="请输入内容"
                      style="
                      width: 90%;
                      padding-top: 10px;
                      padding-bottom: 20px;
                    "
                      disabled
                    >
                      <template slot="prepend">{{ indexs2 + 1 }}</template>
                    </el-input>
                  </div>
                </div>

                <div class="question-operation">
                  <ul>
                    <li>
                      <span class="label-name">判题：</span>
                      <i
                        :class="[
                        'el-icon-check',
                        'iconImg',
                        item.isRight
                          ? 'iconImgTrue'
                          : '',
                      ]"
                        @click="btnTrue(item)"
                      ></i>
                      <i
                        :class="[
                        'el-icon-close',
                        'iconImg',
                        item.isRight
                          ? ''
                          : 'iconImgFalse',
                      ]"
                        @click="btnFalse(item)"
                      ></i>
                    </li>
                    <li>
                      <span class="label-name">得分：</span>
                      <el-input-number
                        v-if="
                        item.isRight
                      "
                        v-model="item.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="item.score"
                        :controls="false"
                        @change="changeScore"
                      ></el-input-number>
                      <el-input-number
                        v-else
                        v-model="item.winScore"
                        :precision="1"
                        :min="0.0"
                        :max="0.0"
                        :controls="false"
                        @change="changeScore"
                      ></el-input-number>
                    </li>
                    <li>
                      <span class="label-name">满分：</span>
                      <span>{{ item.score }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="answer">
                <div v-for="(items, indexs) in item.answer" :key="indexs" class="right-key">
                  <span :title="items.Name">正确答案：{{ items.Name }}</span>
                </div>
              </div>
              <div class="analysis">
                <el-collapse>
                  <el-collapse-item title="答案解析：">
                    <div>
                      <span>{{ item.explain }}</span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </div>
        <!-- 考试信息区域 -->
        <div class="rightPreview">
          <el-scrollbar style="height: 100%">
            <div style="width: 120px; padding: 0 10px; box-sizing: border-box">
              <div class="xinxi-box">
                <span class="text">考试成绩</span>
                <span class="core" v-if="winScoreAll < allScore*0.6">{{ winScoreAll }}分</span>
                <span class="core-pass" v-if="winScoreAll >= allScore*0.6">{{ winScoreAll }}分</span>
              </div>
              <div class="xinxi-box">
                <span class="text">考试状态</span>
                <span class="core-text" v-if="winScoreAll < allScore*0.6">未通过</span>
                <span class="core-success" v-if="winScoreAll >= allScore*0.6">通过</span>
              </div>
              <div class="xinxi-box">
                <span class="text">筛选试题</span>
                <span class="selectAll">
                  <el-select v-model="valueSelect.value" @change="previewSelect(valueSelect.value)">
                    <el-option
                      v-for="item in optionSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <span style="font-size: 14px">{{ item.label }}</span>
                      <i style="font-size: 14px; padding-left: 20px" class="el-icon-check"></i>
                    </el-option>
                  </el-select>
                </span>
              </div>
              <div class="close">
                <el-button type="primary" @click="closeDialog">关闭</el-button>
              </div>
              <div class="submit">
                <el-button type="primary" @click="submitDialog">提交判卷</el-button>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  SelectExam,
  SelectExamUser,
  SelectDrillMaster,
  SelectPaperQuestion,
  delExam,
} from '@/api/exam/achievement';

import { correctExam } from '@/api/exam/exam';

export default {
  //父组件传递过来的值
  props: ['reviewPaperId', 'userId', 'ExamId', 'processId'],
  data() {
    return {
      optionSelect: [
        {
          value: 0,
          label: '全部',
        },
        {
          value: 1,
          label: '答对',
        },
        {
          value: 2,
          label: '答错',
        },
      ],
      valueSelect: {
        value: 0,
      },
      //数据
      examList: [],
      answer: '',
      dxt: 0,
      dxtSum: 0,
      tkt: 0,
      tktSum: 0,
      pdt: 0,
      pdtSum: 0,
      wdt: 0,
      wdtSum: 0,
      ddxt: 0,
      ddxtSum: 0,
      activeNames: ['1'], //折叠面板
      //选中后返回的valueSelect.value
      previewValue: null,
      allScore: 0, //总分
      winScoreAll: 0, //总得分
      flag: false, //关闭页面
    };
  },
  created() {
    this.SelectQuestion();
  },
  methods: {
    //提交判卷
    submitDialog() {
      let para = {
        examId: this.ExamId,
        userId: this.userId,
        processId: this.processId,
        sumScore: this.winScoreAll,
        correctUserId: this.$store.state.User.ids, //改卷用户
      };
      let data = this.examList;
      // debugger
      correctExam(para, data).then((res) => {
        if (res.code !== 200) {
          return this.$message.error('判卷失败！');
        }
        this.$message.success('判卷成功！');
      });
    },
    //关闭弹窗
    closeDialog() {
      this.$emit('closeDialog', this.flag);
    },
    jump(domId) {
      this.$nextTick(() => {
        const returnEle = document.getElementById(domId);
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      });
    },
    //点击标记
    biaoji() {},
    //监听筛选的类型
    previewSelect(value) {
      this.previewValue = value;
    },
    //查看结果
    SelectQuestion() {
      let para = {
        examId: this.reviewPaperId,
        userId: this.userId,
      };
      SelectPaperQuestion(para).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].answer = JSON.parse(res.data[i].answer);
          res.data[i].bjStatus = false;
          this.winScoreAll += res.data[i].winScore;
          // res.data[i].MyCate = false;
          // res.data[i].value = "";
          res.data[i].CheckAnswer = [];
          if (res.data[i].type == 1) {
            this.dxt += 1;
            this.dxtSum += res.data[i].score;
          } else if (res.data[i].type == 2) {
            this.ddxt += 1;
            this.ddxtSum += res.data[i].score;
          } else if (res.data[i].type == 3) {
            this.pdt += 1;
            this.pdtSum += res.data[i].score;
          } else if (res.data[i].type == 5) {
            this.wdt += 1;
            this.wdtSum += res.data[i].score;
          } else if (res.data[i].type == 4) {
            this.tkt += 1;
            this.tktSum += res.data[i].score;
          }
        }
        this.allScore = Number(
          this.dxtSum + this.ddxtSum + this.pdtSum + this.wdtSum + this.tktSum
        );
        this.examList = res.data;
      });
    },
    // 改变分数
    changeScore() {
      this.winScoreAll = 0;
      this.examList.forEach((item) => {
        this.winScoreAll += item.winScore;
      });
    },
    // 选择对的
    btnTrue(row) {
      row.isRight = true;
    },
    // 选择错的
    btnFalse(row) {
      row.isRight = false;
    },
  },
};
</script>

<style scoped>
.container {
  background: #eff3f7;
}
.yiceng {
  padding-top: 30px;
  padding-left: 30px;
  width: calc(100vw - 300px);
  display: flex;
}
.table {
  width: 98%;
  padding-top: 30px;
  padding-left: 30px;
}
.cheat {
  padding-left: 20px;
}
.leftPreview {
  position: sticky;
  top: 20px;
  height: 600px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: white;
  margin-left: 10px;
}
.rightPreview {
  position: sticky;
  top: 20px;
  height: 420px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: white;
  margin: 0 10px;
}
.zhuti {
  width: 80%;
  background-color: white;
  margin-left: 2%;
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-radius: 5px;
}
.leftdiv {
  width: 210px;
  border-bottom: 1px solid rgb(226, 223, 223);
  margin-left: 20px;
}
.title2 {
  font-weight: bold;
  height: 40px;
  padding-top: 5px;
  padding-left: 20px;
  font-size: 18px;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
  background-color: #fafafa;
}
.nr {
  font-size: 10px;
  padding-top: 20px;
  padding-left: 5px;
}
.xinxi-box {
  font-size: 14px;
  padding: 20px 0;
  padding-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #dedede;
}
.xinxi-box .core {
  margin-top: 10px;
  font-size: 18px;
  color: red;
  font-weight: 400;
}
.xinxi-box .core-pass {
  margin-top: 10px;
  font-size: 18px;
  color: blue;
  font-weight: 400;
}
.xinxi-box .core-text {
  margin-top: 10px;
  color: red;
  font-weight: 400;
}
.xinxi-box .core-success {
  margin-top: 10px;
  color: blue;
  font-weight: 400;
}
.xinxi-box .selectAll {
  margin-top: 10px;
  color: blue;
  font-weight: 400;
}
.nav-con {
  width: 100%;
  height: 350px;
  border: 1px solid #f1f3f8;
  border-radius: 5px;
  margin-top: 20px;
}
.nav-con-child {
  color: #b2b8bd;
  margin-left: 45%;
  margin-top: 100px;
}
.leftimg {
  margin-left: 80px;
  margin-top: 200px;
}
.title {
  height: 55px;
  padding-top: 15px;
  font-size: 18px;
  font-weight: bold;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
  background-color: #fafafa;
}
li {
  padding-left: 40px;
  list-style: none;
  padding-bottom: 15px;
}
.sss {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-left: 70px;
  margin-right: 20px;
  width: 90%;
}
.title-box {
  width: 80%;
  display: flex;
  flex-direction: column;
}
.hhh {
  border: 1px solid rgb(226, 223, 223);
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 20px;
}
.btfs {
  margin-left: 80px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.aaa {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-top: 15px;
  border-radius: 2px;
  background-color: #1a8cfe;
}
.top {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-top: 15px;
  background-color: gray;
  border-radius: 2px;
}
.top-true {
  background-color: #1a8cfe;
}
.top-false {
  background-color: red;
}
.bottom {
  height: 20px;
  width: 28px;
  margin-left: 5px;
  margin-bottom: 5px;
  background-color: #f1f3f8;
  border-radius: 2px;
  margin-right: 15px;
}
.analysis {
  width: 92%;
  margin-left: 4%;
  line-height: 40px;
}
.answer {
  display: flex;
  width: 92%;
  margin-left: 4%;
  /* border-top: 1px dashed rgb(226, 223, 223); */
  line-height: 40px;
}
.correct {
  display: flex;
  width: 92%;
  margin-left: 4%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
  font-size: 16px;
}
.mychange {
  display: flex;
  width: 150px;
}
.rightanswer {
  display: flex;
  width: 150px;
}
.subject {
  width: 90%;
  display: flex;
  align-items: baseline;
}
.question-operation {
  background: #fafafa;
  border-radius: 2px;
  padding-right: 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
  cursor: pointer;
}
.question-operation > ul > li {
  padding-left: 0;
}
.iconImg {
  font-size: 20px;
  font-weight: 700;
  border: 1px solid black;
  color: #dad8d8;
  margin-left: 10px;
}
.iconImgTrue {
  background-color: #1a8cfe;
  color: white;
}
.iconImgFalse {
  background-color: red;
  color: white;
}
.allscore-text {
  font-size: 20px;
  font-weight: 600;
  padding: 10px;
}
.close {
  padding: 10px 20px;
}
.submit {
  padding: 10px 10px;
}
</style>